import type { Product, ProductInput } from '@shop-monorepo/types';
import React from 'react';

import { useListReturn } from '../../hooks/useListReturn';
import { useUpdateProduct } from '../../hooks/useProductQueries';
import { ROUTES } from '../../routes/routes';

import { ProductForm } from './ProductForm';

interface EditProductFormProps {
  product: Product;
}

export const EditProductForm: React.FC<EditProductFormProps> = ({ product }) => {
  const { goToList } = useListReturn(ROUTES.PRODUCTS);
  const { mutateAsync: updateProduct, isPending: isSubmitting } = useUpdateProduct();

  const handleSubmit = async (values: ProductInput) => {
    await updateProduct({ id: product.id, product: values });
    goToList();
  };

  return (
    <ProductForm
      initialValues={{
        ...product,
        oldPrice: product.oldPrice === null ? undefined : product.oldPrice,
        brandId: product.brandId === null ? undefined : product.brandId,
        categoryIds: product.categoryIds,
      }}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      excludeProductId={product.id}
    />
  );
};
